export const MUSIC_SUPPORTS_AUDIO_WEIGHT = false
